/* global  navigator  */

export default function isIOS() {
  return (
    typeof navigator !== 'undefined' &&
    !!navigator.platform &&
    /iPad|iPhone|iPod/.test(navigator.platform)
  );
}
